export enum DesignErrorKey {
  expectedIntentError = 'expectedIntentError',
  inputValRulesDescriptionNoEmpty = 'inputValRules::description::noEmpty',
  inputValRulesExternalAudioServiceUrlNoEmpty = 'inputValRules::externalAudioServiceUrl::noEmpty',
  inputValRulesModuleReferenceNoEmpty = 'inputValRules::moduleReference::noEmpty',
  inputValRulesNameNoDuplicateLib = 'inputValRules::name::noDuplicateLib',
  inputValRulesNameNoEmpty = 'inputValRules::name::noEmpty',
  inputValRulesNameObjectName = 'inputValRules::name::objectName',
  inputValRulesPromptReferenceNoEmpty = 'inputValRules::promptReference::noEmpty',
  inputValRulesTimeoutSecondsNoEmpty = 'inputValRules::timeoutSeconds::noEmpty',
  inputValRulesVarNameNoDuplicateVar = 'inputValRules::varName::noDuplicateVar',
  inputValRulesVarNameVariableName = 'inputValRules::varName::variableName',
  validationError = 'validationError'
}

export type DesignErrors = Partial<Record<DesignErrorKey, string>>;
